export abstract class QueryBinding {
  //
}

export class QueryWhereBinding extends QueryBinding {
  constructor(
    public readonly key: string,
    public readonly operatorOrValue: unknown,
    public readonly value: unknown | null = null
  ) {
    super()
  }
}
